import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SegmentLayout } from './SegmentLayout';
export default class Segment extends PureComponent {
  static propTypes = {
    Layout: PropTypes.func
  };
  static defaultProps = {
    Layout: SegmentLayout
  };
  state = {
    isRefundPolicyOpen: false
  };
  /**
  * Открытие модального окна refundPolicy
  */
  openRefundPolicy = () => {
    this.setState({
      isRefundPolicyOpen: true
    });
  };
  /**
  * Закрытие модального окна refundPolicy
  */
  closeRefundPolicy = () => {
    this.setState({
      isRefundPolicyOpen: false
    });
  };
  render() {
    const {
      Layout
    } = this.props;
    const props = {
      ...this.props,
      actions: {
        openRefundPolicy: this.openRefundPolicy,
        closeRefundPolicy: this.closeRefundPolicy
      },
      isRefundPolicyOpen: this.state.isRefundPolicyOpen
    };
    return /*#__PURE__*/React.createElement(Layout, props);
  }
}